import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import ImageWithTextBanner from '../../../components/ImageWithTextBanner';
import GetInTouch from '../../../components/GetInTouch';
import AccordionColumnBox from '../../../components/AccordionColumnBox';
import Link from "next/link"

export default function ContractorsPage({
    global,
    all_contractor_benefits
}) {
    return (
        <>
            <SeoHead
                page_name={`Contractors | The global house of tech and transformation recruitment | Lorien | United States`}
                canonical_link={`contractors`}
                en_gb={false}
                en_us={true}
                
            />
            <MainBanner
                global={global}
                pathPrefix={`us.contractors_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Contractors</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/sub-banner-job-seekers.png`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <AccordionColumnBox
                global={global}
                pathPrefix={`us.contractors_page.accordion_column_box`}
                customClass={`pt-5 grayGradientBg`}
                content={
                    <>
                        <h2>Contractor Benefits</h2>
                    </>
                }
                post={all_contractor_benefits}
            />
            <GetInTouch
                global={global}
                pathPrefix={`us.contractors_page.get_in_touch`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Get in Touch!</h2>
                        <p>Unresolved query? Let us help. Get in touch with the Lorien Contractor and Candidate Support Team to find answers quickly, from information on payments to how to submit your timesheets. No matter how big or small the question, no matter how new or experienced you are to the world of contracting, we'll do our best to give you up-to-date, informed, and helpful answers about working through Lorien as a contractor.</p>
                        <br></br>
                        <h5>Our hotlines are:</h5>
                        <br></br>
                        <p>Contractor Payments <br></br>
                            <Link href={`mailto:agency@lorienglobal.com`}>
                                <a>
                                    <strong>agency@lorienglobal.com</strong>
                                </a>
                            </Link>
                            <br></br>
                            <Link href={`tel:01132002269`}>
                                <a>
                                    <strong> 01132002269</strong>
                                </a>
                            </Link></p>

                        <p>Contracts Team <br></br>
                            <Link href={`mailto:contractsgenQP10@lorienglobal.com`}>
                                <a>
                                    <strong>contractsgenQP10@lorienglobal.com</strong>
                                </a>
                            </Link>
                            <br></br>
                            <Link href={`tel:0113 200 2268`}>
                                <a>
                                    <strong> 0113 200 2268</strong>
                                </a>
                            </Link></p>

                        <p>Pre-employment Screening (PES)<br></br>
                            <Link href={`mailto:PES@lorienglobal.com`}>
                                <a>
                                    <strong>PES@lorienglobal.com</strong>
                                </a>
                            </Link>
                            <br></br>
                            <Link href={`tel:0113 200 2265`}>
                                <a>
                                    <strong> 0113 200 2265</strong>
                                </a>
                            </Link></p>
                        <p>PAYE <br></br>
                            <Link href={`mailto:PAYE@lorienglobal.com`}>
                                <a>
                                    <strong>PAYE@lorienglobal.com</strong>
                                </a>
                            </Link></p>

                    </>
                }
                hard_coded_contacts={
                    <><p><strong> Lorien Main Line:</strong><br></br>
                        <Link href={`tel:954.433.4100`}>
                            <a>
                                954.433.4100
                            </a>
                        </Link>
                    </p>
                        <p><strong> Contractor Payments </strong><br></br>
                            <Link href={`mailto:Contractor.care@lorienglobal.com`}>
                                <a>
                                    Contractor.care@lorienglobal.com
                                </a>
                            </Link>
                            <br></br></p>
                        <p> <strong>Contracts Team</strong> <br></br>
                            <Link href={`mailto:Contractor.care@lorienglobal.com`}>
                                <a>
                                    Contractor.care@lorienglobal.com
                                </a>
                            </Link>
                        </p>
                        <p><strong>Pre-employment Screening (PES)</strong><br></br>
                            <Link href={`mailto:onboarding@impellam.com`}>
                                <a>
                                    onboarding@impellam.com
                                </a>
                            </Link>
                            <br></br>
                            <Link href={`tel:1-888-718-2660`}>
                                <a>
                                    1-888-718-2660
                                </a>
                            </Link>
                        </p>

                    </>
                }
                content_2={``}
                buttonLink={``}
                buttonTitle={``}
                content_3={
                    <>
                        <p>For all other enquiries, please complete our form or reach out to us on <a href="tel:02039109446">02039109446</a>. </p>
                    </>
                }
                formId={`2b80abe6-1370-42a3-b8da-53da7d17be24`}
                successPageUrl={`/us/contractors/submission-success/`}
            />
            <ImageWithTextBanner
                global={global}
                pathPrefix={`contractors_page.image_with_text_banner.2`}
                customClass={`primary-bg`}
                content={
                    <>
                        <h2>Employment and Income Verification</h2>
                        <p>Impellam works with Certree for all employment and income verifications. Past and current employees should visit <a href="https://certree.com/" target="_blank">www.certree.com</a> and create a profile. Once they create a profile, they can generate a free and secure link with their employment and/or income details that can be provided to the person or organization requesting the verification. This site is available 24 hours a day, seven days a week.</p>
                        <p>For other questions about past employment with Impellam and any of our brands (BarPellam, Bartech, Guidant Global, Lorien, or SRG), please contact our <a href="mailto:HR-InfoImpellamNA@impellam.com">People Team</a>.</p>
                    </>
                }
                imageURL={`/site-assets/images/centree-trust.png`}
                imageALT={`Employment and Income Verification Image`}
                buttonLink={`https://certree.com/`}
                buttonTitle={`Read More`}
                newPageTab={true}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const contractor_benefits = (await Collection('contractor_benefits'))
		.filter(function (post) {
			return (
				post.country_tag?.en.includes("US")
			);
		});

    const all_contractor_benefits = contractor_benefits.orderBy('_order').getItems();
    return {
        props: {
            global,
            all_contractor_benefits
        }
    };
}
